import {Box, BoxProps} from '@material-ui/core';
import {Button} from '@wandb/weave/components/Button';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import {clsx} from 'clsx';
import React from 'react';

const HorizontalBox: React.FC<BoxProps> = props => {
  const {className, ...rest} = props;

  return (
    <Tailwind>
      <Box
        {...rest}
        className={clsx(
          'flex flex-shrink-0 flex-row gap-4 overflow-hidden',
          className
        )}
      />
    </Tailwind>
  );
};

export interface PaginationControlsProps {
  currentPage: number;
  totalPages: number;
  startIndex: number;
  endIndex: number;
  totalItems: number;
  onPrevPage: () => void;
  onNextPage: () => void;
  className?: string;
}

export const PaginationControls: React.FC<PaginationControlsProps> = ({
  currentPage,
  totalPages,
  startIndex,
  endIndex,
  totalItems,
  onPrevPage,
  onNextPage,
  className,
}) => (
  <HorizontalBox className={clsx('w-full', className)}>
    <div className="flex items-center justify-center">
      <Button
        variant="ghost"
        onClick={onPrevPage}
        disabled={currentPage === 0}
        icon="chevron-next"
        className="rotate-180"
      />
      <span className="mx-2 pb-2 text-sm text-moon-500">
        {startIndex}-{endIndex} of {totalItems}
      </span>
      <Button
        variant="ghost"
        onClick={onNextPage}
        disabled={currentPage === totalPages - 1}
        icon="chevron-next"
      />
    </div>
  </HorizontalBox>
);
